import jQuery from 'jquery';
import {widget as slideoutWidget} from './slideout-widget';
import accessoriesCarousel from '../partials/product/accesoriesTabs';
import {addServiceProducts as cartServiceAddServiceProduct, removeServiceProduct as cartServiceRemoveServiceProduct} from "../services/cartService";

const widget = jQuery.widget('ep.cartOverlayWidget', slideoutWidget, {
    options: {
        hasChanged: false,
        classes: {
            description: 'cart-slideout-widget__content',
            continueButton: 'add-to-cart-popup-buttons--continue-button',
        },
        popupContent: '',
        triggerElement: undefined,
        listeners: {}
    },
    hasChanged: function () {
        return this.options.hasChanged;
    },
    _addServiceToCartLabelClicked: function (event) {
        this.widget('destroy');
        this._setOption('hasChanged', true);
        this._extendTimer();
        let productCode;
        let serviceProductCode;
        let gotChecked = event.currentTarget.checked;
        let overlaySpinner;

        productCode = $(event.target.parentElement).data('product-code');
        serviceProductCode = $(event.target.parentElement).data('service-product-code');
        overlaySpinner = jQuery('.popup-overlay');

        let promise;
        overlaySpinner.show();
        if (gotChecked) {
            promise = cartServiceAddServiceProduct.apply(window, [productCode, [serviceProductCode]]);
        } else {
            promise = cartServiceRemoveServiceProduct.apply(window, [productCode, serviceProductCode]);
        }
        promise = promise.then((data) => {
            overlaySpinner.hide();
            return this._showCartOverlay(data);
        });
        return promise;

    },
    _showCartOverlay: function (data) {
        if (data.cartData.cartPopup !== '') {
            const popupContent = jQuery('<div/>').append(jQuery(data.cartData.cartPopup)).html();
            const newContent = this._wrapPopupContent(popupContent);
            this._setOption('content', newContent);
        }
    },
    close: function () {
        clearTimeout(this.timerId);
        this._super();
    },
    _create: function () {
        const options = this.options;
        options.content = this._wrapPopupContent(this.options.popupContent);
        options.classes.overlay = 'slideout-widget__overlay';

        this._createTimer();
        this._super();
        this._setOption('triggerElement', options.triggerElement);
        this._setOption('listeners', options.listeners);
    },
    _extendTimer: function () {
        clearTimeout(this.timerId);
        this._createTimer();
    },
    _createTimer: function () {
        this.timerId = setTimeout(() => {
            this.close();
        }, 120000);
    },
    _wrapPopupContent: function (popupContent) {
        return '<div class="' + this.options.classes.description + '">' + popupContent + '</div>';
    },
    _beforeLoadingContent: function () {
        this.element.find('.carousel').carousel('destroy');
    },
    _afterLoadingContent: function () {
        accessoriesCarousel(true);
        setTimeout(() => {
            this.element.find('.slideout-widget__slideout').addClass('minicart__slideouttransform');
        })

        this._on(this.element.find('.' + this.options.classes.continueButton), {
            click: () => {
                this.close();
            }
        });

        const addServiceToCartLabel = this.element.find('.add-to-cart-popup_service-product-input');
        this._on(addServiceToCartLabel, {
            change: '_addServiceToCartLabelClicked'
        });
    },
});

export {widget as widget};

export default function () {
// Nothing to initialize
}
